'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ejson$002dCodecs$0024package$0024 from "./mealorama.json-Codecs$package$.js";
var $p;
/** @constructor */
function $c_Lmealorama_MealORamaClientRepository$$anon$11() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lzio_json_JsonEncoder$();
  $j_mealorama$002ejson$002dCodecs$0024package$0024.$m_Lmealorama_jsonCodecs$package$().a2I();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lzio_json_JsonDecoder$();
  $j_mealorama$002ejson$002dCodecs$0024package$0024.$m_Lmealorama_jsonCodecs$package$().a2I();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lzio_json_JsonEncoder$();
  $j_mealorama$002ejson$002dCodecs$0024package$0024.$m_Lmealorama_jsonCodecs$package$().aTg();
}
export { $c_Lmealorama_MealORamaClientRepository$$anon$11 as $c_Lmealorama_MealORamaClientRepository$$anon$11 };
$p = $c_Lmealorama_MealORamaClientRepository$$anon$11.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MealORamaClientRepository$$anon$11;
/** @constructor */
function $h_Lmealorama_MealORamaClientRepository$$anon$11() {
}
export { $h_Lmealorama_MealORamaClientRepository$$anon$11 as $h_Lmealorama_MealORamaClientRepository$$anon$11 };
$h_Lmealorama_MealORamaClientRepository$$anon$11.prototype = $p;
var $d_Lmealorama_MealORamaClientRepository$$anon$11 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealORamaClientRepository$$anon$11, "mealorama.MealORamaClientRepository$$anon$11", ({
  Gi: 1,
  aM: 1,
  LJ: 1
}));
export { $d_Lmealorama_MealORamaClientRepository$$anon$11 as $d_Lmealorama_MealORamaClientRepository$$anon$11 };
//# sourceMappingURL=mealorama.-Meal-O-Rama-Client-Repository$$anon$11.js.map
